import { render } from "./ModalYoutubeURL.vue?vue&type=template&id=df38e7b8&scoped=true&ts=true"
import script from "./ModalYoutubeURL.vue?vue&type=script&lang=ts"
export * from "./ModalYoutubeURL.vue?vue&type=script&lang=ts"

import "./ModalYoutubeURL.vue?vue&type=style&index=0&id=df38e7b8&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df38e7b8"]])

export default __exports__